import React, { useState, useEffect } from 'react';

export const getDurationFormatted = (duration) => {
    if (duration === null) {
        return ""
    }

    duration = Number(duration);
    var hours = Math.floor(duration / 3600);
    var minutes = Math.floor(duration % 3600 / 60);
    var seconds = Math.floor(duration % 3600 % 60);

    return getTimeFormatted(hours, minutes, seconds);
}

export const getTimeFormatted = (hours, minutes, seconds) => {
    return (hours > 0 ? hours + ":" : "") +
        (minutes > 0 ? (hours > 0 && minutes < 10 ? "0" : "") + minutes + ":" : "0:") +
        (seconds < 10 ? "0" : "") + seconds;
}

export const Countdown = ({ targetDateUtc, isPaused, className }) => {
    const [timeLeft, setTimeLeft] = useState(null);

    const calculateTimeLeft = (targetUtc) => {
        const now = new Date()
        const [year, month, day, hour, minute, second] = targetUtc.split(/[-T:]/)
        const targetDate = new Date(Date.UTC(year, month - 1, day, hour, minute, second))
        const difference = targetDate - now

        if (difference < 0) return { minutes: 0, seconds: 0 };

        const hours = Math.floor((difference / (1000 * 60 * 60)) % 60);
        const minutes = Math.floor((difference / (1000 * 60)) % 60);
        const seconds = Math.floor((difference / 1000) % 60);

        return { hours, minutes, seconds };
    }

    useEffect(() => {
        if (isPaused) return;

        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft(targetDateUtc));
        }, 1000);

        return () => clearInterval(timer);
    }, [targetDateUtc, isPaused]);

    return (
        <>
            {isPaused ? (
                <span className={`${className ?? "text-3xl block"}`}>Paused</span>
            ) : (
                timeLeft && (
                    <span className={`${className ?? "text-3xl block"}`}>
                        {getTimeFormatted(timeLeft.hours, timeLeft.minutes, timeLeft.seconds)}
                    </span>
                )
            )}
        </>
    );
};